<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="coord?.tel" [label]="step4.gettel"
    [type]="'text'" [rule]="rule + 'pattern_8|minSize_10|maxSize_15'"
    [errorMessage]="{'pattern' : 'ctr_208', 'minLength' : 'ctr_208_longueur', 'maxLength' : 'ctr_208_longueur'}"
    [name]="getUid() + '_SepAtt_tel'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="coord?.poste" [label]="step4.getposte"
    [type]="'text'" [rule]="rule + 'maxSize_20'" [errorMessage]="{'required' : 'ctr_303'}" [name]="getUid() + '_SepAtt_poste'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="coord?.fax" [label]="step4.getfax"
    [type]="'text'" [rule]="rule + 'pattern_8|minSize_10|maxSize_15'"
    [errorMessage]="{'required' : 'ctr_303', 'pattern' : 'ctr_209', 'minLength' : 'ctr_209_longueur', 'maxLength' : 'ctr_209_longueur'}"
    [name]="getUid() + '_SepAtt_fax'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="coord?.mel" [label]="step4.getmel"
    [type]="'text'" [rule]="rule + 'maxSize_200|pattern_1'" [errorMessage]="{'required' : 'ctr_303', 'pattern' : 'ctr_33'}" [name]="getUid() + '_SepAtt_mel'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="coord?.url" [label]="step4.geturl"
    [type]="'text'" [rule]="rule + 'maxSize_200|pattern_33'" [errorMessage]="{'required' : 'ctr_303', 'pattern' : 'ctr_7'}" [name]="getUid() + '_SepAtt_url'">
</app-form-input>